import { useSecondModal } from "@helpers/hooks/useSecondModal";
import AccessState from "./components/AccessState";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ShipReturn from "./components/ShipReturn";
import CommonQuestion from "./components/CommonQuestion";
import { useRecoilState } from 'recoil'
import { aboutUs } from '@atoms';
import './style.css'

const AboutUs = ({style}) => {
	const modal = useSecondModal();
	const [aboutStatus,] = useRecoilState(aboutUs);

	let title = () => {
		if (aboutStatus === 'SR') return 'משלוחים והחזרות';
		if (aboutStatus === 'CQ') return 'שאלות נפוצות';
		if (aboutStatus === 'PP') return 'מדיניות פרטיות';
		if (aboutStatus === 'AS') return 'הצהרת נגישות';
		if (aboutStatus === 'HT') return 'כיצד לרכוש בבלנדס'
		return '';
	}
	return (
		<div className="aboutus">
			{/* Close button - X with gray circle */}
			<div
				className="aboutus_close_btn"
				onClick={() => modal('close', 'aboutUs')}
			>
				×
			</div>

			<div className="aboutus_header">
				{title()}
			</div>
			<div className="aboutus_content">
				{ aboutStatus === 'AS' && <AccessState />}
				{ aboutStatus === 'PP' && <PrivacyPolicy />}
				{ aboutStatus === 'SR' && <ShipReturn />}
				{ aboutStatus === 'CQ' && <CommonQuestion />}
			</div>
			<div className="aboutus_footer">
				<button onClick={() => modal('close', 'aboutUs')}>
					סגירה
				</button>
			</div>
		</div>
	);
}

export default AboutUs;
